// extracted by mini-css-extract-plugin
export default {"ImpactNumbers":"ImpactNumber_ImpactNumbers__bbTEH","ImpactNumbersWrap":"ImpactNumber_ImpactNumbersWrap__GK6Jr"};